import { render, staticRenderFns } from "./SurgeryForm.vue?vue&type=template&id=5cb7e3b8&"
import script from "./SurgeryForm.vue?vue&type=script&lang=js&"
export * from "./SurgeryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports